"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Section = _interopRequireDefault(require("../../Section/Section"));
var _GSemployeeRole = _interopRequireDefault(require("../../GSemployeeRole/GSemployeeRole"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.inapp-employees-container {\n  min-height: 600px; }\n  .inapp-employees-container .bottom-section-container {\n    padding: 0px; }\n  .inapp-employees-container .bottom-section {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    width: 100%;\n    justify-content: flex-start;\n    column-gap: 16px; }\n  .inapp-employees-container .employee {\n    align-items: flex-start; }\n  .inapp-employees-container .info-container {\n    margin-left: 0px; }\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(50px); }\n  100% {\n    opacity: 1;\n    transform: translateY(0px); } }\n  .inapp-employees-container .GSemployeeRole-container {\n    animation: 1s cubic-bezier(0.1, -0.6, 0.2, 0) 0s 1 fadeIn; }\n\n@media (max-width: 66rem) {\n  .inapp-employees-container .bottom-section {\n    grid-template-columns: repeat(3, minmax(0, 1fr)); }\n  .inapp-employees-container .info-container {\n    width: 100%;\n    max-width: 312px; } }\n\n@media (max-width: 42rem) {\n  .inapp-employees-container .bottom-section {\n    grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .inapp-employees-container .info-container {\n    width: 100%;\n    max-width: 288px; } }\n";
  const fileName = "InAppEmployees_InAppEmployees";
  const element = document.querySelector("style[data-sass-component='InAppEmployees_InAppEmployees']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Card = /*#__PURE__*/_react.default.memo(_GSemployeeRole.default, (a, b) => {
  return a.picture !== b.picture;
});
const CustomBottomSection = _ref => {
  let {
    element,
    isSelected
  } = _ref;
  const [employees, setEmployees] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    if (isSelected && element.employees && employees.length === 0) getEmployees();
  }, [element, isSelected]);
  const getEmployees = async () => {
    var pictures = await Promise.all(element.employees.map(async el => {
      const picture = el.picture ? await getImage(el.picture) : undefined;
      return typeof picture === 'string' ? picture : undefined;
    }));
    const employeesAux = element.employees.map((el, i) => {
      const picture = pictures[i];
      return {
        ...el,
        picture: picture
      };
    });
    setEmployees(employeesAux);
  };
  const getImage = async pictureURL => {
    const response = await fetch(pictureURL);
    const picture = await response.json();
    return picture;
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "sia-margin-04-top sia-text-13"
  }, element.title), /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom-section"
  }, employees.map(employee => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "employee",
      key: `${employee.firstname}${employee.lastname}`
    }, /*#__PURE__*/_react.default.createElement(Card, employee));
  })));
};
const formatSections = response => {
  const sortedSections = Object.entries(response).sort((el, el2) => el[1].weight - el2[1].weight);
  return {
    page_section_element: sortedSections.sort((el, el2) => el[1].weight - el2[1].weight).map(section => {
      return {
        title: section[0],
        employees: section[1].members?.map(employee => ({
          professional_function: employee.job,
          diploma_title: employee.diploma_title,
          firstname: employee.firstname,
          lastname: employee.lastname,
          phone: employee.phone,
          mobile: employee.mobile,
          email: employee.email,
          gender: employee.gender === 'male' ? 'M' : 'F',
          picture: employee.image || undefined
        }))
      };
    }),
    columns: 3
  };
};
const InAppEmployees = _ref2 => {
  let {
    history,
    lang,
    data
  } = _ref2;
  const [item, setItem] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    if (data) {
      const formatedItem = formatSections(data);
      setItem(formatedItem);
    }
  }, [data]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inapp-employees-container"
  }, item && /*#__PURE__*/_react.default.createElement(_Section.default, {
    item: item,
    CustomBottomSection: CustomBottomSection,
    history: history,
    lang: lang,
    maxElements: 4
  }));
};
InAppEmployees.propTypes = {
  lang: _propTypes.default.string.isRequired,
  history: _propTypes.default.object.isRequired
};
var _default = exports.default = InAppEmployees;